import React from "react";
import { Typography } from "@mui/material";
import { OptionButton } from "shared/components/Inputs/OptionButton";
import { SurveyPreviews } from "modules/MainSurveyEditor/helpers/blockForm";

export const SurveyPreviewField = (props: SurveyPreviewFieldProps) => {
  const { onChange, selectedValue = SurveyPreviews.Inline } = props;

  return (
    <div className="_d-flex-ali-center-f-wrap-sm-gap">
      <OptionButton
        content={<Typography>Inline text</Typography>}
        value={SurveyPreviews.Inline}
        selectedValue={selectedValue}
        onClick={() => onChange(SurveyPreviews.Inline)}
      />
      <OptionButton
        content={<Typography>Card</Typography>}
        value={SurveyPreviews.Card}
        selectedValue={selectedValue}
        onClick={() => onChange(SurveyPreviews.Card)}
      />
    </div>
  );
};

interface SurveyPreviewFieldProps {
  onChange: (value: string) => void;
  selectedValue?: string;
}
